module.exports = __webpack_public_path__ + "static/media/pending.24d4f0b0.svg";